import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
	state:{
		on_break:false,
		barcodeListExists:false,
		subTitle:null,
		activePlace:null,
		activeCheckingPlace:null,
		activeItems:[],
		activeCheckItems:[],  //nincs használva már mert csak egy komponensben van rá szükség így felesleges bonyolítás
		lszsz:null,
		local_right_id:null,
		count_type:null,
		count_types:[
			{id:1,name:'dws'},
			{id:2,name:'obi'},
			{id:3,name:'hervis'},
			{id:4,name:'waikiki'},
			{id:5,name:'rossmann'},
			{id:6,name:'culinaris'},
			{id:7,name:'tesco'},
		],
		data_collection_types: [
			{id:2,name:'one step'},
			{id:1,name:'multi'},
		],
		data_collection_mode:1,
		supervisor_code:"753159852",
		online:true,
		methods:[
			{value:'standard',name:'sima'},
			{value:'status',name:'státusz'},
			{value:'quick',name:'gyors'},
		],
		local_roles:[
			{id:1,name:'számoló'},
			{id:2,name:'megbízó'},
			{id:3,name:'leltárvezető'},
			{id:4,name:'admin'},
			{id:5,name:'backoffice'},
			{id:6,name:'ellenőr'}
		],
		last_barcode_list_refresh:null,
		device_id:null,
		barcode_list_url:null,
		user:null,
		downloading: false,
		downloaded: false,
		time:0,
		place_statuses: [
			{ id: '1',name: 'nincs kiadva' },
			{ id: '2',name: 'számolásra' },
			{ id: '3',name: 'leszámolt' },
			{ id: '4',name: 'rögzítésre' },
			{ id: '5',name: 'rögzítve' },
			{ id: '6',name: '-' },
			{ id: '7',name: '-' },
			{ id: '8',name: '-' },
			{ id: '9',name: '-' },
			{ id: '10',name: 'ellenőrzésre' },
			{ id: '11',name: 'ellenőrzött' },
			{ id: '12',name: 'szuperre' },
			{ id: '13',name: 'szuperezve' }
		],
	},
	mutations: {
		updateDownloading(state,value){
			state.downloading = value;
		},
		updateOnBreak(state,value){
			state.on_break = value;
		},
		updateDownloaded(state,value){
			state.downloaded = value;
		},
		updateTime(state,value){
			state.time = value;
		},
		updateUser(state,value){
			console.log(value);
			state.user = value;
			console.log(state.user);
			console.log('storejs');
		},
		updateUserProperty(state,property,value){
			state.user[property] = value;
		},
		updateBarcodeListUrl(state,barcode_list_url){
			state.barcode_list_url = barcode_list_url;
		},
		updateDeviceId(state,id){
			state.device_id = id;
		},
		updateLastBarcodeListRefresh(state,timestamp){
			state.last_barcode_list_refresh = timestamp;
		},
		updateLocalRightId(state,id){
			state.local_right_id = id;
		},
		updateCountType(state,count_type){
			state.count_type = count_type;
		},
		addToActiveItems(state,item){
			console.log(item);
			console.log(state.activeItems.map(existing_item => existing_item.barcode));
			if(state.activeItems.length == 0 || state.activeItems.map(existing_item => existing_item.barcode).indexOf(item.barcode) == -1){
				state.activeItems.push(item);
				console.log('tureba van');
			}else{
				console.log('elsebe fut');
				console.log(state.activeItems.map(existing_item => existing_item.barcode).indexOf(item.barcode));
				try{
					state.activeItems[state.activeItems.map(existing_item => existing_item.barcode).indexOf(item.barcode)].amount = item.amount;
				}catch(err){
					console.log('error: ')
					console.log(JSON.stringify(state.activeItems));
					console.log(err);
				}
			}
		},
		setActiveCheckItems(state,items){ //nem használjuk mert az ActiveCheckItemshez tartozik ami felesleges
			state.activeCheckItems = items;
		},
		updateActiveCheckItem(state,barcode,check,timestamp){ //nem használjuk mert az ActiveCheckItemshez tartozik ami felesleges
			let item =  state.activeCheckItems[state.activeCheckItems.map(existing_item => existing_item.barcode).indexOf(barcode)];
			item.check = check;
			item.status = true;
			if(!item.timestamp){
				item.timestamp = timestamp;
			}
		},
		addToActiveCheckItems(state,item,status = false){ //nem használjuk mert az ActiveCheckItemshez tartozik ami felesleges
			if(state.activeCheckItems.length == 0 || state.activeCheckItems.map(existing_item => existing_item.barcode).indexOf(item.barcode) == -1){
				let check = null;
				if(item.status == true){
					check = item.amount;
				}
				item.check = check;
				state.activeCheckItems.push(item);
			}else{
				if(status){
					state.activeCheckItems[state.activeCheckItems.map(existing_item => existing_item.barcode).indexOf(item.barcode)].status = status;
				}
				state.activeCheckItems[state.activeCheckItems.map(existing_item => existing_item.barcode).indexOf(item.barcode)].amount = item.amount;
			}
		},
		removeFromActiveItemsByBarcode(state,barcode){
			state.activeItems.splice(state.activeItems.map(item => item.barcode).indexOf(barcode),1);
		},
		deleteActiveItems(state){
			state.activeItems = [];
		},
		deleteActiveCheckItems(state){
			state.activeCheckItems = [];
		},
		updateOnline(state,value){
			state.online = value;
		},
		updateBarcodeListExists(state,value){
			state.barcodeListExists = value;
		},
		updateSubTitle(state,title){
			state.subTitle = title;
		},
		updateActivePlace(state,place){
			state.activePlace = place;
		},
		updateActiveCheckingPlace(state,place){
			state.activeCheckingPlace = place;
		},
		updateLszsz(state,lszsz){
			state.lszsz = lszsz;
		},
		updateDataCollectionMode(state,data_collection_mode){
			state.data_collection_mode = data_collection_mode;
		}
	}
});